<template>
  <div ref="chart" class="chart-container"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    options: {
      type: Object,
      default: () => {},
    },
    renderer: {
      type: String,
      default: "canvas",
    },
    force: {
      type: Boolean,
      default: false,
    },
    subjectData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartInstance: null, // 图表对象
      highlightIndex: 0
    };
  },
  watch: {
    options: {
      handler() {
        if (this.chartInstance) {
          this.chartInstance.clear();
          this.$emit("update:force", false);
        }
        this.initChart();
      },
      deep: true,
    },
    subjectData: {
       handler() {
        if (this.chartInstance) {
          this.chartInstance.clear();
          this.$emit("update:force", false);
        }
        this.initChart();
      },
      deep: true,
    }
  },
  computed: {
    // 默认配置
    baseOptions() {
      return {
        tooltip: {
          trigger: 'item'
        },
        legend: {
         show: false
        },
        series: [
          {
            showEmptyCircle: true,
            name: '学科分布',
            type: 'pie',
            radius: ['60%', '90%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                formatter: ['{a|{d}%}','{c|{b}}'].join('\n'),
                rich: {
                  a: {
                    color: '#134787',
                    fontSize: 30,
                    lineHeight: 43,
                    fontWeight: 500
                  },
                  c: {
                    color: '#262626',
                    fontSize: 13,
                    lineHeight: 30,
                    fontWeight: 500
                  }
                }
              },
            },
            labelLine: {
              show: false
            },
            data: this.subjectData
          }
        ]
      }
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.clear();
      this.chartInstance.dispose();
      window.removeEventListener("resize", this.handleResize);
    }
  },
  methods: {
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    initChart() {
      !this.chartInstance &&
        (this.chartInstance = echarts.init(this.$refs.chart, null, {
          renderer: this.renderer,
        })); // 存在就不做init操作
      this.chartInstance.setOption(
        Object.assign({}, this.baseOptions, this.options)
      );
      const that = this;
      this.chartInstance.on("mouseover", function (e) {
        if (e.dataIndex != that.highlightIndex) {
          that.chartInstance.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: that.highlightIndex,
          });
        }
      });
      this.chartInstance.on("mouseout", function (e) {
        that.highlightIndex = e.dataIndex;
        that.chartInstance.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: e.dataIndex,
        });
      });
      //设置默认选中高亮部分
      this.chartInstance.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: 0,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>
